import { useEffect, useState, memo } from 'react';
import { Platform, TextProps } from 'react-native';
import React from 'react';
import * as Animatable from 'react-native-animatable';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import { Text} from 'tamagui';

interface AnimatedTextProps extends TextProps {
	value: string;
	speed?: number;
	delay?: number;
	fontSize?: number;
	fontColor?: string;
	onAnimationComplete?: Function;
	center?: boolean;
	lineHeight?: number;
	retain?: number;
}

function AnimatedTextFunction({
	value,
	speed = 200,
	delay,
	fontSize = 12,
	fontColor,
	onAnimationComplete,
	lineHeight,
	center,
	retain,
	...props
}: AnimatedTextProps) {
	const [wordIndex, setWordIndex] = useState(0);
	const [opacity, setOpacity] = useState(true);
	const theme = themeSelector();

	if (Platform.OS === 'android') {
		return (
			<Text
				style={{
					flexWrap: 'wrap',
					fontSize: fontSize || 12,
					fontWeight: '400',
					color: "black",
					justifyContent: 'space-evenly',
					textAlign: center ? 'center' : 'justify',
					lineHeightStep: 1.5,
					lineHeight: lineHeight || (fontSize || 26) * 1.5,
				}}
			>
				{value}
			</Text>
		)
	}
	useEffect(() => {
		if (!value) return;



		const words = value.split(' ');

		const displayNextWord = () => {
			if (wordIndex < words.length) {
				setWordIndex((index) => index + 1);
			} else {
				setOpacity(false);
				setTimeout(() => onAnimationComplete && onAnimationComplete(), retain || 1000);
			}
		};

		const timeoutId = setTimeout(displayNextWord, speed);

		return () => clearTimeout(timeoutId);
	}, [wordIndex, onAnimationComplete, value, speed, retain]);

	return (
		<Text
		{...props}
			allowFontScaling={false}
			style={{
				flexWrap: 'wrap',
				fontSize: fontSize || 12,
				fontWeight: '400',
				color: fontColor || "black",
				justifyContent: 'space-evenly',
				textAlign: center ? 'center' : 'justify',
				lineHeight:  24,
			}}
		>
			{value && value.split(' ').slice(0, wordIndex).join(' ')}
			{Platform.OS === 'web' && (
				<Animatable.View useNativeDriver animation="pulse" style={{ opacity: opacity ? 1 : 0, minWidth: 15, flex: 1 }}>
					<Text allowFontScaling={false} animation="fadeIn" style={{ color: theme ? 'white' : 'white', flex: 1, lineHeight: fontSize * 1.5 }}>
						_
					</Text>
				</Animatable.View>
			)}
		</Text>
	);
}

export default memo(AnimatedTextFunction)
